import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { isEmpty } from "lodash";
import React from "react";
import ReactPlayer from "react-player";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  },
  textFormatted: {
    whiteSpace: "pre-line"
  }
}));

const VideoDialog = ({ videoUrl, title, description, onClose }) => {
  const classes = useStyles();
  return (
    <Dialog open onClose={onClose} maxWidth="lg" fullWidth>
      <div className={classes.title}>
        <Typography variant="h5">{title}</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent>
        <ReactPlayer
          url={videoUrl}
          controls
          height="520px"
          width="100%"
          style={{ background: "black" }}
        />
        {!isEmpty(description) && (
          <>
            <br />
            <Typography className={classes.textFormatted}>{description}</Typography>
          </>
        )}
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default VideoDialog;
